'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _listItem = require('../template/list-item.art');
var _listItem2 = _interopRequireDefault(_listItem);
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
var _smoothscroll = require('smoothscroll');
var _smoothscroll2 = _interopRequireDefault(_smoothscroll);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var List = function () {
    function List(player) {
        _classCallCheck(this, List);
        this.player = player;
        this.index = 0;
        this.audios = this.player.options.audio;
        this.bindEvents();
    }
    _createClass(List, [
        {
            key: 'bindEvents',
            value: function bindEvents() {
                var _this = this;
                this.player.template.list.addEventListener('click', function (e) {
                    var target = void 0;
                    if (e.target.tagName.toUpperCase() === 'LI') {
                        target = e.target;
                    } else {
                        target = e.target.parentElement;
                    }
                    var audioIndex = parseInt(target.getElementsByClassName('aplayer-list-index')[0].innerHTML) - 1;
                    if (audioIndex !== _this.index) {
                        _this.switch(audioIndex);
                        _this.player.play();
                    } else {
                        _this.player.toggle();
                    }
                });
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.events.trigger('listshow');
                this.player.template.list.classList.remove('aplayer-list-hide');
                this.player.template.listOl.scrollTop = this.index * 33;
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.events.trigger('listhide');
                this.player.template.list.classList.add('aplayer-list-hide');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (!this.player.template.list.classList.contains('aplayer-list-hide')) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        {
            key: 'add',
            value: function add(audios) {
                this.player.events.trigger('listadd', { audios: audios });
                if (Object.prototype.toString.call(audios) !== '[object Array]') {
                    audios = [audios];
                }
                audios.map(function (item) {
                    item.name = item.name || item.title || 'Audio name';
                    item.artist = item.artist || item.author || 'Audio artist';
                    item.cover = item.cover || item.pic;
                    item.type = item.type || 'normal';
                    return item;
                });
                var wasSingle = !(this.audios.length > 1);
                var wasEmpty = this.audios.length === 0;
                this.player.template.listOl.innerHTML += (0, _listItem2.default)({
                    theme: this.player.options.theme,
                    audio: audios,
                    index: this.audios.length + 1
                });
                this.audios = this.audios.concat(audios);
                if (wasSingle && this.audios.length > 1) {
                    this.player.container.classList.add('aplayer-withlist');
                }
                this.player.randomOrder = _utils2.default.randomOrder(this.audios.length);
                this.player.template.listCurs = this.player.container.querySelectorAll('.aplayer-list-cur');
                this.player.template.listCurs[this.audios.length - 1].style.backgroundColor = audios.theme || this.player.options.theme;
                if (wasEmpty) {
                    if (this.player.options.order === 'random') {
                        this.switch(this.player.randomOrder[0]);
                    } else {
                        this.switch(0);
                    }
                }
            }
        },
        {
            key: 'remove',
            value: function remove(index) {
                this.player.events.trigger('listremove', { index: index });
                if (this.audios[index]) {
                    if (this.audios.length > 1) {
                        var list = this.player.container.querySelectorAll('.aplayer-list li');
                        list[index].remove();
                        this.audios.splice(index, 1);
                        this.player.lrc && this.player.lrc.remove(index);
                        if (index === this.index) {
                            if (this.audios[index]) {
                                this.switch(index);
                            } else {
                                this.switch(index - 1);
                            }
                        }
                        if (this.index > index) {
                            this.index--;
                        }
                        for (var i = index; i < list.length; i++) {
                            list[i].getElementsByClassName('aplayer-list-index')[0].textContent = i;
                        }
                        if (this.audios.length === 1) {
                            this.player.container.classList.remove('aplayer-withlist');
                        }
                        this.player.template.listCurs = this.player.container.querySelectorAll('.aplayer-list-cur');
                    } else {
                        this.clear();
                    }
                }
            }
        },
        {
            key: 'switch',
            value: function _switch(index) {
                this.player.events.trigger('listswitch', { index: index });
                if (typeof index !== 'undefined' && this.audios[index]) {
                    this.index = index;
                    var audio = this.audios[this.index];
                    this.player.template.pic.style.backgroundImage = audio.cover ? 'url(\'' + audio.cover + '\')' : '';
                    this.player.theme(this.audios[this.index].theme || this.player.options.theme, this.index, false);
                    this.player.template.title.innerHTML = audio.name;
                    this.player.template.author.innerHTML = audio.artist ? ' - ' + audio.artist : '';
                    var light = this.player.container.getElementsByClassName('aplayer-list-light')[0];
                    if (light) {
                        light.classList.remove('aplayer-list-light');
                    }
                    this.player.container.querySelectorAll('.aplayer-list li')[this.index].classList.add('aplayer-list-light');
                    (0, _smoothscroll2.default)(this.index * 33, 500, null, this.player.template.listOl);
                    this.player.setAudio(audio);
                    this.player.lrc && this.player.lrc.switch(this.index);
                    this.player.lrc && this.player.lrc.update(0);
                    if (this.player.duration !== 1) {
                        this.player.template.dtime.innerHTML = _utils2.default.secondToTime(this.player.duration);
                    }
                }
            }
        },
        {
            key: 'clear',
            value: function clear() {
                this.player.events.trigger('listclear');
                this.index = 0;
                this.player.container.classList.remove('aplayer-withlist');
                this.player.pause();
                this.audios = [];
                this.player.lrc && this.player.lrc.clear();
                this.player.audio.src = '';
                this.player.template.listOl.innerHTML = '';
                this.player.template.pic.style.backgroundImage = '';
                this.player.theme(this.player.options.theme, this.index, false);
                this.player.template.title.innerHTML = 'No audio';
                this.player.template.author.innerHTML = '';
                this.player.bar.set('loaded', 0, 'width');
                this.player.template.dtime.innerHTML = _utils2.default.secondToTime(0);
            }
        }
    ]);
    return List;
}();
exports.default = List;